document.addEventListener('change', (event) => {
  const target = event.target;

  if (!(target instanceof HTMLInputElement || target instanceof HTMLSelectElement)) return;

  const picker = target.closest('variant-picker');
  if (!picker) return;

  const optionName = target.dataset.optionName?.trim().toLowerCase();

  if (optionName !== 'style') return;

  setTimeout(() => {
    const sizeInputs = Array.from(
      picker.querySelectorAll('input[data-option-name="Size"]')
    );

    if (!sizeInputs.length) return;

    const currentSize = sizeInputs.find((input) => input.checked);

    // If current size is still a valid selectable size, leave it alone
    if (
      currentSize &&
      !currentSize.closest('label')?.classList.contains('disabled') &&
      currentSize.dataset.variantId
    ) {
      return;
    }

    // Find the first size Horizon says belongs to a valid variant
    const firstValidSize = sizeInputs.find((input) => {
      return (
        input.dataset.variantId &&
        !input.closest('label')?.classList.contains('disabled')
      );
    });

    if (firstValidSize && !firstValidSize.checked) {
      firstValidSize.click();
    }
  }, 500);
});